import React, { useEffect, useState } from 'react';
import { Button, Link, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, Grid, IconButton } from '@mui/material'
import DashboardContainer from '../../components/DashboardContainer';
import PageContainer from '../../components/PageContainer';
import { useSnackbar } from 'notistack';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import CustomDataGrid from '../../components/CustomDataGrid';
import { getList } from '../../redux/api/system';

const ListMdaAdmins = () => {
  const [ processing, setProcessing ] = useState(false);
  const [ records, setRecords ] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  
  const columns = [
    { field: 'name', headerName: 'Name', width: 300 },
    { field: 'email', headerName: 'Email', width: 300 },
    { field: 'instituionName', headerName: 'Institution Name', width: 300 },
    { field: 'phoneNumber', headerName: 'Phone Number', width: 200 },
    { field: 'roleName', headerName: 'Role Name', width:200 }
  ];

  const generateRandom = () => {
    var length = 8,
        charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  };

  const init = async () => {
    try {
        setProcessing(true)
        const resp = await getList("admin_contacts");

        if(resp?.responseCode === "00") {
            setRecords(resp?.listing || [])
            //setDatasets(response?.listing || [])
        } else {
            enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    }
    catch (err) {
        enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
    }
    finally {
        setProcessing(false)
    }
}

useEffect(() => {
  init()
}, [])


  return (
    <PageContainer pageTitle='Data Views' processing={processing}>
      <section className="inner-banner parallax-section">
          <div className='overlay'>
              <div className="container">
                  <div className="row">
                      <div className="col-md-12 col-sm-12">
                          <h3 className="wow bounceIn" data-wow-delay="0.9s">MDA</h3>
                          <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">ADMIN CONTACT DETAILS</h1>
                      </div>
                  </div>
              </div>
          </div>
      </section>
      {/* <div className="services-area section-padding pt-3">
        <div className="container">
          <div style={{ height: '80vh', width: '100%', marginTop: '30px' }}>
            <DataGrid
              className=''
              columns={columns}
              getRowId={(row) =>  generateRandom()}
              rows={records}
              //checkboxSelection={false}
              //disableSelectionOnClick
              components={{ Toolbar: GridToolbar }}
            />
          </div>
        </div>
      </div> */}
      <div className="services-area section-padding pt-3">
        <div className="container">
          <div style={{ height: '80vh', width: '100%', marginTop: '30px' }}>
            <CustomDataGrid
              className=''
              columns={columns}
              getRowId={(row) =>  generateRandom()}
              rows={records}
              //checkboxSelection={false}
              //disableSelectionOnClick
              // components={{ Toolbar: GridToolbar }}
            />
          </div>
        </div>
      </div>
    </PageContainer>
  )
}

export default ListMdaAdmins;